import { useAppContext } from '../Services/AppContext';

const useTranslation = () => {
	const { translation } = useAppContext();

	const handleTranslate = (key: string | undefined, params?: any) => {
		if (!key) {
			return undefined;
		}

		// @ts-ignore
		let trans = translation[key] || key;

		if (params) {
			for (const paramKey in params) {
				trans = trans.replace(`%${paramKey}%`, params[paramKey]);
			}
		}

		return trans;
	};

	return {
		t: handleTranslate,
	};
};

export default useTranslation;
